/* globals document */
/* eslint react/jsx-filename-extension: "off" */

import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';

import rootReducer from './reducers/reducers';
import api from './middleware/api';

import setupRollbar from './modules/rollbar';

import App from './components/App';

setupRollbar();

const createStoreWithMiddleware = applyMiddleware(thunkMiddleware, api)(createStore);
const store = createStoreWithMiddleware(rootReducer);

 // Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

// Expose a small global config object - this is used just for Google
// Analytics at the moment. Modifying it does nothing.
window.pronounceConfig = {
  lang: 'en-GB',
};

render(
  <MuiThemeProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </MuiThemeProvider>
  ,
  document.getElementById('pronounce-app'),
);



// WEBPACK FOOTER //
// ./src/index.js